import { Button } from '@avanta/shared/components/ui/Button';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { type Row } from '@tanstack/react-table';
import { Calendar } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { type RecentPatientDTO } from 'types/appointments';
import { useBookSession } from './hooks/useBookSession';

interface BookButtonProps {
  row: Row<RecentPatientDTO>;
}

export const BookButton = ({ row }: BookButtonProps): React.ReactElement | null => {
  const { t } = useTranslation(LOCIZE_NS.PSYCHOLOGIST);
  const { handleBookAppointment, isLoading, center } = useBookSession(row.original.id);

  if (!center) return null;

  return (
    <Button
      isLoading={isLoading}
      className="text-xs w-43"
      onClick={handleBookAppointment}
      icon="leading"
    >
      <Calendar size={8} />
      {t('PsychologistPatients.bookAppointment.cta')}
    </Button>
  );
};
